import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";
import { api, translateApiError } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("common.success"));
      navigate("/login");
    } catch (err) {
      toast.error(translateApiError(err, t));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("auth.reset.title")} subtitle={token ? "" : "Invalid or missing token."} testId="reset-page">
      <form className="space-y-4" onSubmit={onSubmit}>
        <div>
          <Label htmlFor="password">{t("auth.password")}</Label>
          <Input id="password" type="password" required minLength={6} value={password}
            onChange={(e) => setPassword(e.target.value)} className="h-12 mt-1" data-testid="reset-password-input" />
        </div>
        <Button type="submit" size="lg" className="w-full h-12" disabled={loading || !token} data-testid="reset-submit-button">
          {loading ? t("common.loading") : t("auth.reset.submit")}
        </Button>
      </form>
      <div className="mt-8 text-center text-sm">
        <Link to="/login" className="text-primary hover:underline">← {t("auth.forgot.back")}</Link>
      </div>
    </AuthShell>
  );
}
